// import { useEffect, useMemo, useState } from "react";
// import { getQuestion } from "../../pages/api/hello";
// import reactStringReplace from "react-string-replace";
// import FaqAccordion from "../QuestionList";

// const DescriptionTab = ({ content, isPopup, hidden= true }: any) => {
//     // const [hasInnerText, setHasInnerText] = useState(true);
//     // useEffect(() => {
//     //     if (content.indexOf("<img") < 0) {
//     //         setHasInnerText(false);
//     //     }
//     //     // setHasInnerText(false);
//     // }, [content])
//     const [categoryQuestion, setCategoryQuestion] = useState<any[]>([]);

//     /* ===============================
//         1️⃣ LẤY QUESTION IDS TỪ CONTENT
//     =============================== */
//     useEffect(() => {
//         if (!content || !content.includes("question-")) return;

//         const match = content.match(/question-\[(\d+(?:,\d+)*)\]/);
//         if (!match) return;

//         const ids = match[1];

//         (async () => {
//         const res = await getQuestion("ids=" + ids);
//         setCategoryQuestion(res || []);
//         })();
//     }, [content]);

//     const resultCase = useMemo(() => {
//         if (!categoryQuestion.length) return content;

//         const questionIds = categoryQuestion.map((q: any) => q.id).toString();
//         const questionId = `question-[${questionIds}]`;

//         const questionRegex = new RegExp(
//         `<div\\s+id="${questionId.replace("[", "\\[").replace("]", "\\]")}"[\\s\\S]*?<\\/div>`,
//         "g"
//         );

//         return reactStringReplace(content, questionRegex, () => (
//         <FaqAccordion questions={categoryQuestion} />
//         ));
//     }, [content, categoryQuestion]);
//     console.log("🚀 ~ file: description_tab.tsx:63 ~ resultCase:", resultCase);
//     return (
//         <div className={`tab_description ${hidden ? "hidden" : ""}`}>
//             <div className="lg:flex w-full hide_scrollbar">
//                 {content && (
//                 <div
//                     id="form_in_modal_group_content"
//                     className="bg-white w-full h-auto mx-auto"
//                 >
//                     <div id="form_in_modal_group_contentrte_view">
//                         <div
//                             id="form_in_modal_group_content_rte-edit-view_descr"
//                             tabIndex={0}
//                             className="e-lib e-keyboard"
//                         >
//                             {resultCase}
//                         </div>
//                     </div>
//                 </div>
//                 )}
//             </div>
//         </div>
//     );
// }

// export default DescriptionTab;
import { useEffect, useMemo, useState } from "react";
import parse from "html-react-parser";
import FaqAccordion from "../QuestionList";
import { getQuestion } from "../../pages/api/hello";


const DescriptionTab = ({
  content,
  hidden = true,
  className = "",
}: any) => {
  const [questions, setQuestions] = useState<any[]>([]);

  /* =========================
     1️⃣ LẤY QUESTION IDS
  ========================= */
  useEffect(() => {
    if (!content) return;
    const regex = /<div[^>]*id="question-\[(\d+(?:,\d+)*)\]"[^>]*>\s*Danh mục câu hỏi\s*<\/div>/;
    const match = content.match(regex);
    if (!match) return;

    const ids = match[1];
    (async () => {
      try {
        const res = await getQuestion("ids=" + ids);
        setQuestions(res || []);
      } catch (err) {
        console.error("Get question error", err);
      }
    })();
  }, [content]);
  const parser = new DOMParser();
  /* =========================
     2️⃣ PARSE HTML + REPLACE
  ========================= */
  const renderedContent = useMemo(() => {
    if (!content) return null;
    return parse(content.replace(/\\"/g, '"'), {
      replace: (node: any) => {
        if(node.name === "img"){
            let image = node.attribs;
            let img_src_old = image.src;
            if(window.innerWidth < 700){
              var pathParts = image.src.split("/");
              var filenameWithExt = pathParts[pathParts.length - 1];
              // Get the extension only ("webp")
              var filenameParts = filenameWithExt.split(".");
      
              // Get the filename without the extension ("bang-gia-vest-nam")
              var filename_new = filenameParts[0] + "_530." + "webp";//+ filenameParts[filenameParts.length - 1];
              //Output: bang-gia-vest-nam_530.webp
              
              var src_new = image.src.replaceAll(filenameWithExt, filename_new);
              image.src = src_new;
              image.width = 530;
              image.height = 265;
            }
            
            image.loading = 'eager';
            image.fetchPriority = 'high';
            image.onError = (e:any) => {
              e.currentTarget.src = img_src_old;
            };
          
            return node;
        }
        
        if (
          node.name === "div" &&
          node.attribs?.id?.startsWith("question-[")
          // questions.length > 0
        ) {
          return (
            <div className="w-full my-6">
              <FaqAccordion questions={questions} />
            </div>
          );
        }
        return undefined;
      },
    });
  }, [content, questions]);

  /* =========================
     3️⃣ RENDER
  ========================= */
  return (
    <div className={`tab_description ${className ? className : ""} ${hidden ? "hidden" : ""}`}>
        <div
          id="form_in_modal_group_content_rte-edit-view_descr"
          className="prose max-w-none"
        >
          {renderedContent}
        </div>
    </div>
  );
};

export default DescriptionTab;